import { Checkbox as UnionCheckbox } from "@xo-union/tk-component-switches";
import React from "react";
export var Checkbox = function Checkbox(_ref) {
  var field = _ref.field,
    setFieldValue = _ref.form.setFieldValue,
    _ref$invert = _ref.invert,
    invert = _ref$invert === void 0 ? false : _ref$invert,
    _ref$enabledText = _ref.enabledText,
    enabledText = _ref$enabledText === void 0 ? 'Yes' : _ref$enabledText,
    _ref$disabledText = _ref.disabledText,
    disabledText = _ref$disabledText === void 0 ? 'No' : _ref$disabledText,
    _ref$labelDirection = _ref.labelDirection,
    labelDirection = _ref$labelDirection === void 0 ? 'right' : _ref$labelDirection;
  var name = field.name,
    value = field.value;
  var checked = value;
  if (invert) {
    checked = !value;
  }
  var onChange = function onChange(e) {
    if (invert) {
      setFieldValue(name, !e.target.checked);
      return;
    }
    setFieldValue(name, e.target.checked);
  };
  return /*#__PURE__*/React.createElement(UnionCheckbox, {
    "data-testid": "checkbox",
    checked: checked,
    labelDirection: labelDirection,
    onChange: onChange
  }, checked ? enabledText : disabledText);
};